import { getFeatureAppNames } from './FinanceUtils';
export const trackLayerClose = (trackingService, value, appContext) => {
    const { eventName, componentName } = getFeatureAppNames(appContext);
    if (trackingService) {
        trackingService.track({
            event: {
                eventInfo: {
                    eventAction: 'content',
                    eventName: `${eventName} - close modal layer`,
                },
                attributes: {
                    componentName,
                    label: '',
                    targetURL: '',
                    clickID: '',
                    elementName: 'text link',
                    value,
                    pos: '',
                },
            },
            componentUpdate: {
                page: {
                    pageInfo: {
                        pageID: '',
                    },
                    attributes: {
                        promotionName: '',
                    },
                },
            },
        });
    }
};
